
import styles from './Intro.module.scss';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Intro() {


    // const location = useLocation();
    // const navigate = useNavigate();
    // const queryParams = new URLSearchParams(location.search);
    // const pageid = queryParams.get('pageid');

    // const [activeTab, setActiveTab] = useState(1);
    // useEffect(() => {
    //     if (pageid) {
    //         setActiveTab(Number(pageid));
    //     }
    // }, [pageid]);

    // const handleTabClick = (tabIndex) => {
    //     setActiveTab(tabIndex);
    //     navigate(`?pageid=${tabIndex}`);
    // };
    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>차세대공학리더 소개</span>
                {/* <div className={styles.tab_box}> */}
                    {/* <button
                        className={`${styles.tab_btn} ${activeTab === 1 ? styles.active : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        차세대공학리더
                    </button> */}
                    {/* <button
                        className={`${styles.tab_btn} ${activeTab === 2 ? styles.active : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        Senior 소개
                    </button> */}
                    {/* <button
                        className={`${styles.tab_btn} ${activeTab === 2 ? styles.active : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        설립목적 및 비전
                    </button>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 3 ? styles.active : ''}`}
                        onClick={() => handleTabClick(3)}
                    >
                        차세대공학리더 정관
                    </button> */}
                {/* </div> */}
                <div className={styles.intro_content_wrap}>
                    {/* {activeTab === 1 && ( */}
                        <div>
                            <div className={styles.intro_flex_wrap}>
                                <div className={styles.left_box}>
                                    <span className={styles.intro_cont}>
                                        <div className={styles.f_16}>
                                            Young Engineers Honor Society (YEHS)<br />
                                            YEHS는 한국공학한림원 산하의<br />
                                            대한민국 공과대학 학우들의 연합 모임입니다<br />
                                        </div>
                                        <br />
                                        YEHS는 여러 학교에서 다양한 전공에 몸담고 있는 공학도들 사이의 교류를 활성화 하고 장기적으로 전국적인 규모의 공대생 네트워크를 구축하기 위해 국내 여러 대학의 공학도들이 모여 설립한 조직입니다.<br />
                                        YEHS는 여러 대학교의 총장 및 공대 학장의 추천을 통해 회원을 선발하고 있으며, 현재 경희대학교, 고려대학교, 단국대학교, 동국대학교, 부산대학교, 서강대학교, 서울대학교, 성균관대학교, 아주대학교, 연세대학교, 영남대학교, 이화여자대학교, 인하대학교, 중앙대학교, 충남대학교, KAIST, 포항공과대학교, 한양대학교 등 여러 학교의 재학생 및 졸업생들이 참여하고 있습니다.<br />
                                        YEHS는 끝없는 잠재력을 지닌 공학도들이 앞으로 각계에서 우리나라를 이끌 수 있는 리더로 성장하기 위해 역량을 키울 수 있는 모임이 되고자 합니다.<br />
                                        또한 YEHS는 다양한 전공을 가지고 있는 공학도들, 그리고 여러 학교의 학우들이 서로간의 친목을 다지고 학술적으로 교류할 수 있는 장을 제공하고자 합니다.<br />
                                        앞으로 YEHS가 발전해가는 모습을 관심을 가지고 지켜봐 주시기를 부탁드립니다.<br />
                                    </span>
                                </div>
                                <div className={styles.right_box}>
                                    <img src="/img/yehs_intro.jpg" alt="" />
                                </div>
                            </div>
                            <div className={styles.intro_iframe}>
                                <span>차세대공학리더(YEHS) 홍보 영상</span>
                                <iframe
                                    title="차세대공학리더(YEHS) 홍보 영상"
                                    src="https://play-tv.kakao.com/embed/player/cliplink/425231751?service=kakao_tv"
                                    frameBorder="0"
                                    allowFullScreen
                                    style={{ width: '100%', height: '100%' }}
                                ></iframe>
                            </div>
                        </div>
                    {/* )} */}

                    {/* {activeTab === 2 && (
                        <div className={styles.intro_flex_wrap}>
                            <div className={styles.left_box}>
                                <span className={styles.intro_cont_2}>
                                    YEHS Senior는 한국공학한림원 산하의
                                    YEHS출신 젊은 과학기술인들의 연합 모입니다.<br />
                                    YEHS 출신의 대한민국 젊은이들이 국가 및 국제 사회에 기여하는 차세대 글로벌 과학기술 도전자들로 다같이 성장하기 위해 다시 뭉쳤습니다. YEHSenior는 사회 각 분야에서 과학기술을 바탕으로 더 나은 세상을 만들겠다는 꿈을 같이 꾸면서 활동하고 있는 한국공학한림원 산하의 YEHS 출신 젊은 과학기술인의 모임입니다.<br />

                                    과학기술은 사회의 변혁을 이끄는 핵심적인 동인입니다. 사회로 진출한 YEHS인들은 이/공학 교육을 배경으로, 사회의 다양한 변화를 이끄는 최전선에서 활발하게 활동하고 있습니다. 산업계에서 연구개발 인력으로, 기술경영 분야에서 경영인으로, 학계에서 대학원생 및 연구원으로, 공공 분야에서의 정책 인력으로, 그 외에도 사회 각 분야에서 변화와 혁신을 이끄는 도전자로 - YEHS인은 사회에 진출한 후에도 YEHSenior의 이름으로 모여 더 훌륭한 인재로 성장하여, 다같이 더 나은 세상을 만들기 위한 노력을 계속하려 합니다.<br />
                                    이를 위해 YEHSenior는 다양한 분야에서 활동하고 있는 YEHS인들 사이에 인간적인 교분을 나눌 수 있고 지식과 경험을 공유할 수 있는 교류의 장을 열어, YEHS인들이 앞으로 각계에서 대한민국과 세계를 이끄는 리더로 성장할 수 있는 지속적인 바탕을 마련하고자 합니다. 앞으로 YEHS, 그리고 YEHSenior가 같이 발전해나가는 모습을 관심을 가지고 지켜봐 주시기를 부탁합니다.<br />

                                    YEHSenior는 YEHS에서 진취적인 비전과 성실한 활동, 우수한 역량을 보인 젊은 공학도들 중에서 회원을 선발하고 있습니다. 저희와 같이 과학기술을 통해 더 나은 세상을 만들어가자는 꿈에 동참하고 싶으신 젊은 공학도들께서는 YEHS의 문을 두드려 주시기 바랍니다.
                                </span>
                            </div>
                            <div className={styles.right_box}>
                                <img src="/img/yehs_intro_2.jpg" alt="" />
                            </div>
                        </div>
                    )} */}

                    {/* {activeTab === 2 && (
                        <>
                            <span className={styles.intro_cont_2}>
                                <b>설립목적</b><br />
                                다양한 배경을 지닌 공대생 사이의 교류를 활성화하여 다양한 이공계 분야를 아우르는 전국적인 공대생 네트워크를 구축한다.<br />
                                차세대공학리더로서의 잠재력을 가진 이공계 학생들에게, 앞으로 훌륭한 리더로 성장하는 데 요구되는 능력과 소양을 갖출 수 있도록 다양한 기회를 제공한다.<br />
                                공학적 배경을 가진 차세대 리더를 양성한다.<br />
                                <b>Vision</b><br />
                                다양한 산업, 학계, 정책 분야에서의 역량과 리더십을 갖추고,이를 바탕으로 국가 및 국제사회에 기여하는 차세대 글로벌 과학기술 도전자(Global Engineering Leaders)단체<br />
                                <b>Mission</b><br />
                                우리는 과학기술과 관련된 다양한 산업, 학계, 정책 분야에서 장차 대한민국의 미래를 짊어질 차세대 과학 기술지도자를 양성한다.<br />
                                이를 위해 우리는 공학도로서 각 분야에 탁월한 공학적 능력을 기르고, 다양한 분야에 대한 지식과 경험을 학습하고 공유한다.<br />
                                우리는 개개인의 역량을 개발하는 것에서 멈추지 않고, 도덕적 리더십을 갖추고 사회에 기여하기 위한 노력을 게을리하지 않는다.<br />
                                <b>Core Values</b>
                            </span>
                            <div className={styles.center_img_box}>
                                <img src="/img/yehs_intro_3.jpg" alt="" className={styles.center_img} />
                            </div>

                        </>

                    )} */}

                    {/* {activeTab === 3 && (
                        <div>
                            <div className={styles.center_img_box}>
                                <img src="/img/yehs_intro_4.png" alt="" />
                            </div>
                            <div className={styles.intro_download}>
                                일자별 정관 다운로드 :
                                <a href="/img/YEHS_statute_201219.pdf" download>2020.12.19</a>|
                                <a href="/img/YEHS_statute_191221.pdf" download>2019.12.21</a>|
                                <a href="/img/YEHS_statute_181222.pdf" download>2018.12.22</a>|
                                <a href="/img/YEHS_statute_171222.pdf" download>2017.12.22</a>|
                                <a href="/img/YEHS_statute_121227.pdf" download>2012.12.27</a>|
                                <a href="/img/YEHS_statute_101228.pdf" download>2010.12.28</a>
                            </div>
                            <pre className={styles.intro_cont_4} dangerouslySetInnerHTML={{
                                __html: `
제 1 장 총 칙 (總 則)
제 1 조 【명 칭】
① 본 모임의 정식 명칭은 ‘Young Engineers Honor Society’ (이하 'YEHS')으로 한다.
② 필요에 따라 ‘한국공학한림원 차세대공학리더’라는 이름을 같이 사용할 수 있다.
제 2 조 【모임의 목적】
① YEHS는 회원들에게 차세대공학리더로 성장하는 데 요구되는 능력과 소양을 갖출 수 있는 다양한 기회를 제공하여 공학적 배경을 가진 리더를 양성한다.
② YEHS는 전국 공학도들 사이의 교류를 활성화하여 전국적인 공대생 네트워크를 구축하는 것을 목적으로 한다.
③ YEHS는 여러 활동을 통해 사회에 기여하고 봉사하는 것을 목적으로 한다.
④ YEHS의 모든 활동은 영리를 목적으로 하지 않는다.
제 2 장 회 원 (會 員)
제 3 조 【회원】
① YEHS는 YEHS 회원(이하 “회원”이라 한다)으로 구성한다.
② 회원은 정회원, 준회원으로 구분한다.
③ 정회원은 시니어 회원, 주니어 회원으로 구분한다.
④ 준회원은 주니어 회원으로 구분한다.
제 4조 【회원의 자격】
① 대한민국 각 대학의 총장 또는 공과대학 학장의 추천을 받아 한국공학한림원의 NAEK포럼 및 그에 준하는 형식의 행사에 참석한 자를 회원으로 선발한다. 위의 과정으로 선발된 회원은 준회원의 자격을 가진다.
② 준회원 중 정회원 평가 관련 세부 규정에 따라 자격 요건이 성립된 자는 정회원의 자격을 가진다.
③ 정회원 중 다음 각 호의 자격 요건이 성립된 자는 시니어 회원의 자격을 가진다.
  1. 학사학위 취득 이후 취직 경력이 있는 정회원
  2. 박사학위 과정에 있거나 박사학위를 취득한 정회원
  3. 석사학위와 박사학위의 과정이 통합된 과정을 4학기 이상을 완료한 정회원
제 5 조 【회원의 권한】
① 회원은 본 모임에서 기획한 모든 회원활동에 참여할 수 있다.
② 회원은 본 모임의 활동에 의견을 개진할 권리를 가진다.
제 6 조 【회원의 제명】
다음 각 호의 조건을 만족하는 회원은 총회의 의결을 통해 제명할 수 있다.
  1. YEHS의 명예를 훼손한 회원
  2. YEHS의 목적에 위배되는 행위를 한 회원
  3. 총회와 운영위원회에서 결의된 사항을 따르지 않은 회원
제 3 장 임 원
제 7 조 【임 원】
YEHS에 다음의 임원을 두며, 모든 임원은 비상근으로 한다.
회장       1인
부회장    6인
제 8 조 【임원의 선출】
① 회장의 후보는 본 모임의 정회원 중 운영위원회의 추천을 받은 자에서 결정한다.
② 부회장의 후보는 본 모임의 회원 중 운영위원회의 추천을 받은 자에서 결정한다.
③ 회장과 부회장의 선출은 총회에서 후보에 대한 임명 승인에 의한다.
제 9 조 【임원의 임기】
① 임원의 임기는 1년으로 한다.
② 차기 임원을 선임하기 전에 임기가 만료된 경우에는 그 임기만료 직후에 개최되는 총회 종료일까지 그 임기를 연장한다. 단, 그 기간은 6개월을 초과하지 아니한다.
제 10 조 【임원의 업무 및 권한】
① 본 모임의 회장은 다음 각 호의 업무 및 권한을 갖는다.
  1. 본 모임을 대표하며 그 업무를 총괄
  2. 중앙운영위원회의 의장이 되어 그 업무를 주관
  3. 총회의 의결사항 중 회장의 직무에 해당하는 사항을 집행
  4. 중앙운영위원회와 총회를 소집
  5. 그 밖의 회장의 직무에 관한 중요한 사항
② 본 모임의 부회장은 다음 각 호의 업무 및 권한을 갖는다.
  1. 각 부서의 장이 되어 그 업무를 주관
  2. 중앙운영위원회의 위원이 되어 그 업무를 수행
  3. 각 부서의 부장과 차장의 추천
  4. 부서별 업무 회의를 소집
  5. 그 밖의 부회장의 직무에 관한 중요한 사항
제 11 조 【임원의 궐위 또는 부재】
① 회장의 궐위 또는 부재 시 부회장 중 1인을 운영위원회에서 지목하여 다음 총회까지 그 직무를 대행한다.
② 부회장의 궐위 또는 부재 시 운영위원회에서 직무 대행자를 임명하여 다음 총회까지 그 직무를 대행한다.
제 12 조 &lt;삭제 2017. 12. 22.&gt;
제 13 조 &lt;삭제 2017. 12. 22.&gt;
제 4 장 총 회
제 14 조 【총회의 지위】
① 총회는 본 모임의 제반 활동에 대한 사안을 토의, 결정한다.
② 총회는 본 모임의 모든 결정사항에 있어 최고 의결권을 가진다.
제 15 조 【총회의 의장】
의장은 총회의 운영 전반을 관장하며, 대외적으로 총회를 대표한다.
① 총회의 의장은 회장이 한다.
② 회장의 궐위 또는 부재 시 부회장 중 중앙운영위원회에서 지목한 1인이 의장을 맡는다.
제 16 조 【총회의 소집】
① 총회는 정기총회와 임시총회를 둔다.
② 정기총회는 매 연말에 의장이 소집한다.
③ 임시총회는 다음 각 호 중 하나에 의해 소집된다.
  1. 회장의 소집 요구
  2. 운영위원회의 1/2 이상의 참석과 출석위원 2/3 이상의 찬성을 통한 소집 요구
  3. 전체 정회원 1/20 이상의 연서를 통한 소집 요구
④ 총회가 소집될 시, 본 모임의 회장은 회의 안건을 명기하여 개회 7일 전까지 공식적인 경로를 통하여 공지하여야 한다.
제 17 조 【총회의 기능】
총회는 다음 각 호의 업무와 권한을 갖는다.
  1. 회원의 제명에 관한 사항
  2. 임원의 임명 및 해임 결정에 관한 사항
  3. &lt;삭제 2017. 12. 22.&gt;
  4. 정관개정에 관한 사항
  5. 운영에 관하여 필요한 세부 규정의 제정 및 개정에 관한 사항
  6. 사업계획의 승인
  7. 상임위원의 자격 승인
  8. 기타 중요한 사항
제 18 조 【총회의 정족수】
① 총회는 지난 정기총회의 다음날부터 당 총회까지 YEHS의 회원활동에 참여한 정회원 1/5의 참석으로 개회한다. 단, 출석 정회원이 20인 미만일 경우 개회하지 아니한다.
② 총회의 의사는 출석 정회원 과반수의 찬성으로 의결 및 승인한다. 단, 가부동수일 경우 의장은 적절한 토의과정을 거쳐 재표결을 결정할 수 있다.
③ 개회 선포 이후에 들어온 회원은 참관인으로 규정하고, 정족수에서 제외한다.
제 19 조 【총회결의의 제척사유】
① 회원은 다음 각 호에 해당하는 때에 한하여 그 의결에 참여하지 못한다.
  1. 회원의 제명에 관한 사항에 있어 본인에 해당될 경우
  2. 임원의 임명 및 해임 결정에 관한 사항에 있어 본인에 해당될 경우
  3. 기타 중요한 사항에 있어 본인에 해당될 경우
② 본조 제1항의 제3호에 있어 필요성이 인정될 경우, 의장의 권한으로 해당하는 회원의 의결 참여가 허가된다.
제 20 조 【총회의 의사록】
총회의 회의록은 반드시 남기도록 하며, 의장 및 의장이 지명하는 부회장 1인과 출석 정회원 3인 이상이 기명 날인하여 보관하고, 그 내용을 회원에게 공식적인 경로를 통하여 공지하여야 한다.
제 5 장 중 앙 운 영 위 원 회
제 21 조 【중앙운영위원회의 지위】
중앙운영위원회는 본 모임의 상설 운영기구이다.
제 22 조 【중앙운영위원회의 구성】
중앙운영위원회는 본 모임의 임원으로 구성된다.
제 23 조 【중앙운영위원회의 의장】
의장은 중앙운영위원회의 운영 전반을 관장하며, 대외적으로 중앙운영위원회를 대표한다.
① 중앙운영위원회의 의장은 본 모임의 회장이 한다.
② 회장의 궐위 또는 부재 시 부회장 중 운영위원회에서 지목한 1인이 의장을 맡는다.
제 24 조 【중앙운영위원회의 기능】
중앙운영위원회는 다음 각 호의 업무와 권한을 갖는다.
  1. 본 모임의 재정 · 회계의 심의 및 조정에 관한 사항
  2. 운영위원회의 소집과 구성 및 해체에 관한 사항
  3. 운영위원회의 업무 진행에 관한 전반적인 내용 검토 및 심의에 관한 사항
  4. 운영위원회의 운영위원 임면 및 직책 결정에 관한 사항
  5. 학교대표의 임면에 관한 사항
  6. 학교대표협의회의 회의로의 안건 상정에 관한 사항
  7. 집행위원회 소집과 구성 및 해체에 관한 사항
  8. 인권위원회의 소집과 구성 및 해체에 관한 사항
  9. 회원활동 운영 규정 제정에 관한 사항
  10. 기타 총회의 의결을 요하지 않는 제반 사항
제 25 조 【중앙운영위원회결의의 제척사유】
① 중앙운영위원회의 위원은 다음 각 호에 해당하는 때에 한하여 그 의결에 참여하지 못한다.
  1. 기타 제반 사항에 있어 본인에 해당될 경우
② 본조 1항의 1호에 있어 필요성이 인정될 경우, 의장의 권한으로 해당하는 위원의 의결 참여가 허가된다.
제 6 장 운 영 위 원 회
제 26 조 【운영위원회의 지위】
운영위원회는 본 모임의 운영기구이다.
제 27 조 【운영위원회의 구성】
① 운영위원회의 구성은 다음의 각 호를 따라 중앙운영위원회에서 결정한다.
  1. 운영위원회는 본 모임의 임원과 중앙운영위원회에서 임명한 운영위원으로 구성된다.
  2. 분야 별 업무를 담당하여 총괄하는 6개의 관리 부서를 둔다.
  3. 각 부서의 장은 해당 부서의 부회장이 담당하여 부서의 운영 전반을 관장하며, 대외적으로 각 부서를 대표한다.
② 운영위원회의 위원은 다음의 각 호를 따라 중앙운영위원회에서 임명한다.
  1. 운영위원은 본 모임에 회원으로 속해야 한다.
  2. 운영위원은 본 모임에 회원으로 속해야 한다.
  3. 각 부서의 속한 운영위원 중 최대 2인은 속한 부서의 부장으로 임명한다.
  4. 각 부서의 속한 운영위원 중 필요한 인원은 속한 부서의 차장으로 임명한다.
제 28 조 【운영위원회의 의장】
의장은 운영위원회의 운영 전반을 관장하며, 대외적으로 운영위원회를 대표한다.
① 운영위원회의 의장은 본 모임의 회장이 한다.
② 다음의 각 호의 상황이 발생 시 부회장 중 운영위원회에서 지목한 1인이 의장을 대행한다.
  1. 본 모임의 회장에 대한 해임안의 논의될 경우.
  2. 의장이 궐위 또는 부재일 경우.
제 29 조 【운영위원회의 회의】
① 운영위원회는 정기회의와 임시회의를 둔다.
② 임시회의는 다음 각 호 중 하나에 의해 소집된다.
  1. 의장의 소집 요구
  2. 운영위원 과반수의 소집 요구
제 30 조 【운영위원회의 기능】
운영위원회는 다음 각 호의 업무와 권한을 갖는다.
  1. 본 모임의 관리 부서별 제반 업무에 관한 사항
  2. 정관 개정안의 발의 및 총회로의 안건 상정에 관한 사항
  3. 세부 규정의 제정/개정안의 발의 및 총회로의 안건 상정에 관한 사항
  4. 총회에서 의결된 사업 계획 운영에 관한 사항
  5. 임원의 추천에 관한 사항
  6. 임원의 해임안 발의 및 총회로의 안건 상정에 관한 사항
  7. 회원활동의 회비 책정과 수납 방법에 관한 사항
  8. 회원활동 회비가 과도하게 책정되었을 때에 대한 해명과 초과분의 환급에 관한 사항
  9. 학교대표협의회가 상정한 논의안의 논의와 답변에 관한 사항
  10. 회원활동 참여의 제한에 대한 처분 취소 요구 심의 및 취소에 관한 사항
  11. 기타 총회의 의결을 요하지 않는 본 모임 운영의 제반 사항
제 31 조 【운영위원회의 정족수】
① 운영위원회는 전체 운영위원 1/2 이상의 참석으로 개회한다.
② 운영위원회의 의사는 출석 위원 과반수의 찬성으로 의결한다.
제 32 조 【운영위원회결의의 제척사유】
① 운영위원회의 위원은 다음 각 호에 해당하는 때에 한하여 그 의결에 참여하지 못한다.
  1. 임원의 추천에 관한 사항에 있어 본인에 해당될 경우
  2. 임원의 해임안 발의에 관한 사항에 있어 본인에 해당될 경우
  3. 기타 제반 사항에 있어 본인에 해당될 경우
② 본조 1항의 3호에 있어 필요성이 인정될 경우, 의장의 권한으로 해당하는 위원의 의결 참여가 허가된다.
제 33 조 【운영위원회의 의사록】
운영위원회 회의의 회의록은 대외비를 제거하여 반드시 남기도록 하며, 의장 및 의장이 지명하는 출석 위원 2인 이상이 기명 날인하여 보관하고, 그 내용을 운영위원에게 공식적인 경로를 통하여 공지하여야 한다.
제 34 조 [제7장으로 이동 2019. 12. 21.]
제 35 조 &lt;삭제 2017. 12. 22.&gt;
제 36 조 &lt;삭제 2017. 12. 22.&gt;
제 7 장 상 임 위 원 회
제 37 조 【상임위원회의 지위】
상임위원회는 본 모임의 상설 자문기구이다.
제 38 조 【상임위원회의 구성】
① 상임위원회는 상임위원의 자격을 갖는 회원으로 구성한다.
② 상임위원의 자격은 다음 각 호를 따라 부여한다.
  1. 본 모임에서 1년 이상 회장직을 역임한 회원은 무기한 상임위원으로서의 자격을 갖는다.
  2. 본 모임에서 1년 이상 부회장직을 역임할 경우 3년 기한 상임위원으로서의 자격을 갖는다.
  3. 본 모임의 회원으로서 임원에 상응한 공적이 있을 경우 상임위원회의 추천과 총회의 승인으로 3년 기한 상임위원으로서의 자격을 갖는다.
제 39 조 【상임위원회의 기능】
상임위원회는 다음 각 호의 업무와 권한을 갖는다.
  1. 중앙운영위원회 및 운영위원회의 자문 요청에 응답
  2. 본 모임의 발전 계획에 관한 의견 제시
  3. 집행위원회의 자문위원으로 활동
제 8 장 집 행 위 원 회
제 40 조 【집행위원회의 지위】
집행위원회는 본 모임의 운영에 있어 특별한 목적을 수행하기 위한 집행기구이다.
제 41 조 【집행위원회의 구성】
집행위원회는 집행 사안별로 다음 각 호를 따라 중앙운영위원회가 소집한다.
  1. 일반집행위원은 본 모임의 정회원으로 속해야 한다.
  2. 특수집행위원은 본 모임의 회원으로 속하며, 특별히 집행 사안의 수행에 필요한 회원으로 한다.
  3. 자문위원은 본 모임의 상임위원으로 속해야 한다.
제 42 조 【집행위원회의 기능】
집행위원회는 다음 각 호의 업무와 권한을 갖는다.
  1. 집행위원회가 집행할 사안에 대한 의사 결정
  2. 의사 결정의 결과 집행
제 9 장 인 권 위 원 회
제 43 조 【인권위원회의 지위】
인권위원회는 각 인권 침해 사건의 조사처리와 대응 방안을 심의의결하기 위한 운영기구이다.
제 44 조 【인권위원회의 업무와 권한】
인권위원회는 다음 각 호의 업무 및 권한을 갖는다.
  1. 인권 침해 사건에 대한 공식적인 조사처리 및 대응 방안 의결
  2. 인권 침해 사건의 피해자 보호 및 요청 사항 이행
  3. 인권 침해 사건의 조사처리 및 대응을 위한 자원 요청 및 동원
  4. 인권 침해 사건에 대한 운영 주체의 대응 요구
  5. 기타 사건 처리를 위한 제반 사항의 의결
제 45 조 【인권위원회의 구성】
인권위원회는 인권 침해 사건의 접수 시 다음 각 호를 따라 중앙운영위원회가 신속히 소집한다.
  1. 인권위원회는 중앙운영위원회 위원과 본 모임의 회원으로서 특별히 인권 침해 사건 처리에 필요한 회원으로 구성된다.
  2. 단, 해당 인권 침해 사건에 유관한 회원은 인권위원회의 위원이 될 수 없다.
제 46 조 【인권위원회의 위원장】
위원장은 인권위원회의 사건 처리대응 전반을 관장하며, 대외적으로 인권위원회를 대표한다.
① 인권위원회의 위원장은 본 모임의 회장이 한다.
② 다음의 각 호의 상황이 발생 시 부회장 중 운영위원회에서 지목한 1인이 의장을 대행한다.
  1. 본 모임의 회장이 인권 침해 사건에 유관할 경우
  2. 회장이 궐위 또는 부재일 경우
제 47 조 【인권위원회의 회의】
① 인권위원회의 회의는 다음 각 호 중 하나에 의해 소집된다.
  1. 인권위원회 소집을 기준으로 2주에 1회 위원장의 소집
  2. 기타 위원장의 소집 요구
  3. 인권위원회의 위원 1/3 이상의 소집 요구
  4. 피해자의 소집 요구
② 인권위원회의 첫 회기는 인권 위원회 소집을 기준으로 14일 이내여야 한다.
③ 인권위원회의 회의 내용은 회의 폐회 3일 이내로 피해자에게 공유되어야 한다.
제 48 조 【인권위원회의 정족수】
① 인권위원회는 전체 인권위원회 위원 2/3 이상의 참석으로 개회한다.
② 인권위원회의 의사는 출석 위원 2/3 이상의 찬성으로 의결한다.
제 49 조 【인권위원회의 제척사유】
①인권위원회의 위원은 다음 각 호에 해당하는 때에 위원 자격을 박탈한다.
  1. 인권 침해 사건의 조사 중 위원이 유관함을 발견하였을 경우
제 50 조 【인권위원회의 존속기간】
인권위원회는 소집된 때로부터 사후 처리에 대한 모든 논의가 완료된 때까지 존속한다.
제 10 장 학 교 대 표
제 51 조 【학교대표】
본 모임을 구성하는 학교 마다 해당 학교를 대표하는 학교대표를 둔다.
제 52 조 【학교대표의 구성】
학교대표는 다음의 각 호를 따라 중앙운영위원회에서 임명한다.
  1. 학교대표는 본 모임에 회원으로 속해야 한다.
  2. 학교대표는 본 모임을 구성하는 학교 마다 전임 학교대표와 회원관리부가 추천한 후보 중 1인으로 임명한다.
제 53 조 【학교대표의 업무와 권한】
본 모임의 학교대표는 다음 각 호의 업무 및 권한을 갖는다.
  1. 본 모임을 구성하는 각 학교를 대표하며 그 업무를 총괄
  2. 학교대표협의회의 위원이 되어 그 업무를 수행
  3. 소속 학교를 대표하는 학교대표의 후보 추천
  4. 그 밖의 학교대표 직무에 관한 중요한 사항
제 54 조 【학교대표협의회의 지위】
학교대표협의회는 본 모임의 협의기구이다.
제 55 조 【학교대표협의회의 구성】
학교대표협의회는 본 모임의 학교대표로 구성된다.
제 56 조 【학교대표협의회의 의장】
학교대표협의회의 의장은 학교대표협의회의 운영 전반을 관장하며, 대외적으로 학교대표협의회를 대표한다.
① 학교대표협의회의 의장 선출은 학교대표협의회의 회의에서 다음 각 호의 원칙을 따라 임명한다.
  1. 비밀투표
  2. 결선투표
② 다음 각 호의 상황이 발생 시 학교대표 중 학교대표협의회에서 지목한 1인이 의장을 대행한다.
  1. 학교대표협의회의 의장에 대한 해임안이 논의될 경우
  2. 학교대표협의회의 의장이 궐위 또는 부재일 경우
제 57 조 【학교대표협의회의 회의】
① 학교대표협의회는 정기회의와 임시회의를 둔다.
② 정기회의는 각 상반기와 하반기 내에 의장이 소집한다.
③ 임시회의는 다음 각 호 중 하나에 의해 소집된다.
  1. 의장의 소집 요구
  2. 학교대표협의회의 위원 과반수의 소집 요구
제 58 조 【학교대표협의회의 기능】
학교대표협의회는 다음 각 호의 업무와 권한을 갖는다.
  1. 본 모임을 구성하는 학교별 제반 업무에 관한 사항
  2. 학교대표 간 업무 공조에 관한 사항
  3. 중앙운영위원회가 상정한 안건 논의에 관한 사항
  4. 본 모임의 운영에 대한 공식 의견 논의에 관한 사항
  5. 학교대표협의회의 공식 의견에 대한 논의안 발의 및 운영위원회로의 안건 상정에 관한 사항
  6. 학교대표협의회의 의장 임면에 관한 사항
  7. 기타 운영위원회의 의결을 요하지 않는 본 모임 운영의 제반 사항
제 59 조 【학교대표협의회의 정족수】
① 학교대표협의회는 전체 학교대표협의회 위원 2/3 이상의 참석으로 개회한다.
② 학교대표협의회의 의사는 출석 위원 과반수의 찬성으로 의결한다.
③ 학교대표협의회의 위원은 대리인을 통하여 의결권을 행사할 수 없다. 단, 개회 전까지 위임장을 의장에게 제출함으로써 위임대표를 통하여 의결권을 행사할 수 있다.
제 60 조 【학교대표협의회의 제척사유】
① 학교대표협의회의 위원은 다음 각 호에 해당하는 때에 한하여 그 의결에 참여하지 못한다.
  1. 위원의 추천 및 변경에 관한 사항에 있어 본인에 해당될 경우
  2. 위원의 해임안 발의에 관한 사항에 있어 본인에 해당될 경우
  3. 기타 제반 사항에 있어 본인에 해당될 경우
② 본조 1항 3호에 있어 필요성이 인정될 경우, 의장의 권한으로 해당하는 위원의 의결 참여가 허가된다.
제 11 장 회 원 활 동
제 61 조 【회원활동의 정의】
본 모임의 모든 회원이 참여할 수 있는 운영위원회의 기획 행사를 회원활동이라 한다. 본 모임에서 기획된 모든 회원활동은 다음의 각 호에 따라 분류되어야 한다.
  1. 사회 공헌 활동
  2. 학술 교류 활동
  3. 회원 교류 활동
제 62 조 【회원활동의 회비】
① 회원활동의 회비는 회원활동이 원활히 운영될 수 있도록 활동에 참여한 회원이 분담하는 운영 지원금을 말한다.
② 회원활동의 회비는 운영위원회의 의결을 통해 회비의 액수, 납부기한, 납부방식이 결정된다.
③ 활동에 참가한 회원은 회비를 납부할 의무를 지닌다.
④ 회비를 납부한 회원은 회비의 액수가 과도하게 책정되었을 때, 책정 기준에 대한 해명과 초과분에 대한 환급을 운영위원회로 요구할 권리를 지닌다.
제 63 조 【회원활동 참여의 제한】
① 본 모임의 회원은 회원 활동의 참여에 있어 다음 각 호에 따라 제한을 받을 수 있다.
  1. 본 모임의 회원은 중앙운영위원회가 의결하여 사전에 공지한 운영 규정에 따라 제한 요건에 해당될 경우 회원 활동 참여에 있어 제한을 받을 수 있다.
  2.본 모임의 회원은 인권위원회가 인권 침해 사건을 조사하여 의결한 피해자 보호 대응 방안에 따라 제한 요건에 해당될 경우 회원 활동 참여에 있어 제한을 받을 수 있다.
② 본 모임의 회원은 본인에게 가해진 회원활동 참여의 제한에 대하여, 제한 통보를 수령한 후 1개월 이내에 운영위원회로 이의제기 및 처분 무효 요구를 주장할 권리가 있다.
제 12 장 재 정 · 회 계
제 64 조 【재정】
① 다음 각 호에 해당하는 재산을 YEHS의 일반재산으로 한다.
  1. 각 회원의 행사참가회비
  2. 지원금 및 찬조금
  3. 재산으로 인해 발생하는 각종 수익 및 손해
  4. 기타 일반자산으로 포함될 수 있는 항목으로 운영위원회에서 의결한 재산
② 본 모임의 활동에 필요한 경비는 일반재산으로 충당한다.
제 65 조 [제7장으로 이동 2017. 12. 22.]
제 66 조 【재정의 관리】
① 총무직은 회장이 담당하되, 특별한 사유가 있는 경우 운영위원회의 의결을 통해 다른 임원이 해당직을 대행할 수 있다.
② 본 모임의 재산의 관리 및 회계 업무는 운영위원회에서의 의결을 통해 특별히 관리하기로 결정한 사항을 제외하고 총무직이 담당한다.
③ 재정 관리를 위한 계좌는 회장의 명의로 개설하여, 총무직이 관리한다.
제 67 조 【회계】
① 총무직은 재산상태 및 수입 및 지출 내역을 정확하게 파악할 수 있도록 회계 업무를 수행한다.
② 본 모임의 회계연도는 당해 정기총회의 다음날로부터 다음해 정기총회까지로 한다.
③ 해당 회계연도에 잉여분이 발생한 경우 다음 회계연도로 이월한다.
제 13 장 보 칙
제 68 조 [부칙으로 이동 2017. 12. 22.]
제 69 조 【정관의 변경】
이 정관을 변경하고자 할 때에는 운영위원회 위원 중 3분의 2이상의 찬성과 총회의 의결을 거쳐야 한다.
제 70 조 【의사록의 작성】
총회 및 운영위원회의 의사록은 다음 사항을 기재하여야 한다.
  1. 총회 및 운영위원회의 일시 및 장소
  2. 회원총수 및 출석회원 명부
  3. 회의 내용
  4. 의결사항 및 찬부의 수
제 71 조 【운영세칙】
본 모임의 운영에 관하여 필요한 세부사항은 운영위원회에서 정하고 총회의 승인을 받아야 한다.

정회원 평가 관련 세부 규정
제 1 장 총 칙
제 1 조 【목적】
이 세부 규정은 정회원 평가의 절차를 규정함으로써 원활한 정회원 평가가 이루어지도록 함을 목적으로 한다.
제 2 조 【원칙】
정회원 평가는 본 모임의 회원 자격을 공정하게 결정하는 과정이어야 한다.
제 2 장 정 회 원 자 격
제 3 조 【분기별 조건】
① 2019년 1월 이전의 CEO포럼 및 NAEK포럼 초청자는 정회원의 자격을 부여 받기 위하여 다음 각 호를 요구된 분기에 성립하여야 한다.
  1. YEHS 세미나 1회 참여
  2. YEHS 공식 대외 행사 1회 참여
② 2019년 1월 이후의 NAEK포럼 초청자는 정회원의 자격을 부여 받기 위하여 다음 각 호를 요구된 분기에 성립하여야 한다.
  1. 학술 교류 활동 1회 참여
  2. 사회 공헌 활동 1회 참여
제 4 조 【정회원의 자격】
① 2009년 9월 이전의 CEO포럼 초청자는 다음 각 호를 따라 정회원 자격이 주어진다.
  1. 정회원 평가는 본 모임에 가입한 날로부터 2년간 6개월의 분기로 총 4회 이루어진다.
  2. 4개의 분기 중 제3조의 분기별 조건을 2회 연속 충족 시 정회원 자격이 주어진다.
② 2009년 9월 이후의 CEO포럼 및 NAEK포럼 초청자는 다음 각 호를 따라 정회원 자격이 주어진다.
  1. 정회원 평가는 본 모임에 가입한 날로부터 1년 6개월 간 6개월의 분기가 종료되는 월 말마다 총 3회 이루어진다.
  2. 3개의 분기 중 제3조의 분기별 조건을 2회 충족 시 정회원 자격이 주어진다.
제 5 조 【정회원 평가】
① 정회원 평가는 매월 말 일괄적으로 시행한다.
② 정회원 재평가는 정회원 평가가 진행되는 기간 안에 정회원 자격을 얻지 못한 회원이 재평가를 신청하였을 때 다음 각 호를 따라 시행한다.
  1. 정회원 재평가는 재평가를 신청한 날로부터 1년간 6개월의 분기로 총 2회 이루어진다.
  2. 정회원 평가에서 분기별 조건을 1회 이상 만족했을 경우, 2개의 재평가 분기 중 제3조의 분기별 조건을 1회 충족 시 정회원 자격이 주어진다.
  3. 정회원 평가에서 분기별 조건을 만족하지 못했을 경우, 2개의 재평가 분기 중 제3조의 분기별 조건을 2회 충족 시 정회원 자격이 주어진다.
  4. 재평가는 총 2회까지 신청할 수 있다.
제 6 조 【정회원 평가 유예】
① 제4조의 정회원 평가 분기 내에 다음 각 호의 사유로 활동이 불가한 회원은 정회원 평가 분기 유예를 신청할 수 있다.
  1. 군 복무
  2. 교환 학생
  3. 어학 연수
  4. 운영위원회가 인정하는 기타 사유
② 정회원 평가 유예 기간은 본조 1항에 해당하는 사유의 기간 이하로 정한다.
제 7 조 【정회원 평가 기간 연장】
① 국가 재난 사태 등으로 인하여 정회원 평가에 충분한 빈도의 회원 활동이 개최되기 어려운 경우 운영위원회의 의결을 통해 각 회원이 속해 있는 정회원 평가 및 재평가 기간을 일괄적으로 연장할 수 있다.
② 정회원 평가 연장 기간은 본조 1항에 해당하는 사유의 기간 이하로 운영위원회의 의결을 통해 결정한다.
부 칙 
제 1 조 【발효 및 시행】
이 정관은 총회에서 의결되어, 총회의 의장이 공포한 시점부터 발효, 시행된다.

총 회 시 행 세 부 규 정
제 1 장 총 칙
제 1 조 【목적】
이이 세칙은 본 모임의 총회 진행에 관한 사항을 규정함으로써 민주적으로 회의를 진행하도록 함을 목적으로 한다.
제 2 조 【원칙】
본 모임의 총회는 본 모임의 의사를 민주적으로 결정하는 과정이어야 한다.
제 3 조 【회의 용어】
① 회기(會期)는 개회에서 폐회까지의 기간을 말한다.
② 개회(開會)는 총회를 시작하는 것을 말한다.
③ 정회(停會)는 총회 도중 사정에 의하여 회의를 일시 중단하는 것을 말한다.
④ 속개(續開)는 정회 후 총회를 다시 진행하는 것을 말한다.
⑤ 유회(流會)는 개회 또는 속개 전 개회 정족수를 충족하지 못하여 총회를 진행할 수 없을 때 총회를 끝내는 것을 말한다.
⑥ 폐회(閉會)는 총회를 끝내는 것을 말한다.
제 2 장 회 의 진 행 원 칙
제 4 조 【공개의 원칙】
① 총회는 본 모임의 회원을 대상으로 공개를 원칙으로 한다.
② 본 모임의 회원은 총회에 참여할 권리를 갖는다.
제 5 조 【일의제의 원칙】
① 총회 중에는 한 번에 한 가지 안건만을 다루고, 두 가지 이상의 안건을 동시에 논의하지 아니한다.
② 총회 중에는 한 번에 한 가지 안건만을 다루고, 두 가지 이상의 안건을 동시에 논의하지 아니한다.
제 6 조 【발언자유의 원칙】
① 본 모임의 회원은 발언의 자유를 보장받으며 이를 박탈당하지 아니한다. 단 필요한 경우 의장은 발언자유를 유보할 수 있다.
② 의장의 발언자유 유보가 부당하다고 판단할 때에는 결정에 대하여 공소 동의안을 제출하여 과반수 찬성으로 가결할 수 있다.
제 7 조 【다수결의 원칙】
다수의 의견에 따라 안건의 가부를 결정함을 원칙으로 한다.
제 8 조 【소수의견 존중의 원칙】
다수의 의견에 따라 안건의 가부를 결정함을 원칙으로 한다.
제 9 조 【합의, 결의의 원칙】
모안 이외에는 다른 안건이 채택된 경우라 할지라도 합의안을 만들고 결의하는 과정으로 회의를 진행한다.
제 10 조 【일수부재의의 원칙】
① 한 번 처리된 안건은 해당 회기 중에 다시 상정할 수 없다.
② 해당 회기 중 이미 처리된 안건을 재상정하기 위해서는 출석 정회원 2/3 이상이 재의에 찬성해야 한다.
제 3 장 회 의 구 성
제 11 조 【의결권】
본 모임 내 모든 정회원의 의결권은 동등하다.
제 12 조 【의장】
의장은 총회의 운영 전반을 관장하며, 의장은 회장이 한다. 회장의 궐위 또는 부재 시 중앙운영위원회 위원에서 호선한다.
제 13 조 【사회자】
총회의 사회자는 중앙운영위원회 위원 중 1인이 담당한다. 불가피한 사유 발생 시 운영위원회의 부장 중 호선한다.
제 14 조 【회순】
개회로부터 폐회에 이르는 회순은 각 호에 의한다.
  1. 개회 선언
  2. 회의 진행 세부 규정 확인
  3. 안건 채택 및 회순 통과
  4. 안건 심의 및 표결
  5. 기타 건의 사항 확인
  6. 폐회 선언
제 15 조 【개회】
① 총회는 개회 정족수를 확인하여 충족하였을 경우 개회한다.
② 개회 정족수는 활동 정회원 1/5 이상이다. 이때, 참석한 활동 정회원이 20인 미만일 경우 개회 정족수를 충족하지 못한 것으로 한다.
제 16 조 【정회, 유회, 폐회】
① 회의 중 다음 각 호에 해당하는 경우 의장은 정회를 선언할 수 있다.
  1. 회의 중 다음 각 호에 해당하는 경우 의장은 정회를 선언할 수 있다.
  2. 의사진행과 관련하여 조정이 필요한 경우
  3. 출석 정회원의 과반수 찬성으로 정회가 결정된 경우
② 다음 각 호에 해당하는 경우 의장은 유회를 선언하고 회의를 종료한다.
  1. 개회를 시도하였으나 개회 정족수(활동 정회원 1/5 이상 출석 및 20인 이상 출석)를 충족하지 못한 경우
  2. 정회 후 속개를 시도하였으나 속개 정족수를 충족하지 못한 경우
③ 모든 안건에 대한 논의가 끝나는 경우 의장은 폐회를 선언하고 회의를 종료한다. 
제 17 조 【속개】
① 정회 후 총회를 재개하고자 할 때에는 개회 시에 출석했던 정회원으로 한하여 속개 정족수를 확인하여 충족하였을 경우 속개한다. 
② 속개 정족수는 개회 정족수와 동일하다.
③ 속개 정족수를 충족하지 못한 경우, 유회를 선언하고 회의를 종료한다.
제 18 조 【의사조정위원회】
① 회의 중 의사진행과 관련하여 조정이 필요할 때 이를 중재하기 위해 출석 정회원 과반수의 찬성으로 의사조정위원회를 소집할 수 있다. 
② 의사조정위원회는 중앙운영위원회 위원으로 구성함을 원칙으로 한다.
제 19 조 【안건】
① 총회에서 심의해야 할 대상을 안건이라 한다.
② 안건의 종류는 다음 각 호로 구분한다.
  1. 보고 안건 사업 보고, 감사 보고 등이 이에 해당한다.
  2. 논의 안건: 정관 및 세부규정의 제개정, 임원 선출 안건 등이 이에 해당한다.
제 20 조 【안건 채택】
① 총회의 안건은 운영위원회에서 제안한 것을 모안으로 하며 총회 14일 전까지 의장에게 제출한다.
② 운영위원 5인 이상의 연서 또는 본 모임의 정회원 1/20 이상의 연서와 함께 총회 3일 전까지 의장에게 제출된 안건 또한 총회 안건으로 인정한다.
③ 본조 1, 2항의 절차를 거치지 않은 것을 안건으로 다루려는 경우 ‘안건 채택 및 회순 통과’ 과정에서 다음 각 호의 절차를 따른다. 단, 경우에 따라 ‘안건 채택 및 회순 통과’ 과정 이후에도 안건을 추가로 채택할 수 있으며, 그 절차 역시 본조 본항에 따른다.
  1. 제안자의 제안 설명
  2. 안건 채택 여부에 대한 찬반토론
  3. 안건 채택 여부에 대한 표결
  4. 출석 대의원 과반수 찬성으로 안건 채택
제 21 조 【회순 통과】
① 총회 회순은 중앙운영위원회에서 제안한 것을 기본으로 한다.
② ‘안건 채택 및 회순 통과’ 과정에서 본조 1항에 제안된 회순의 변경을 제안할 수 있고, 회순의 변경은 의사조정위원회의 합의로 결정한다.
③ ‘안건 채택 및 회순 통과’ 과정 이후 회순 변경은 변경 동의안을 받아 찬반토론 없이 출석 정회원 과반수 찬성으로 결정한다.
제 22 조 【각 안건 심의 및 표결 순서】
각 안건 심의 및 표결 순서는 다음과 같다.
  1. 안건 상정
  2. 원안에 대한 제안 설명
  3. 질의 및 답변
  4. 원안에 대한 찬반 토론
  5. 수정안 제출 여부 및 제안 설명 ― 수정안이 없으면 안건에 대한 표결
  6. 수정안에 대한 질의 및 답변 (수정안이 있을 경우)
  7. 수정안에 대한 찬반 토론
  8. 원안과 수정안 중 안건 상정에 대한 표결
  9. 채택된 안건에 대한 표결
제 4 장 의 사 진 행
제 23 조 【발언권】
① 본 모임의 회원은 의장에게 발언권을 요청하여 허가를 받음으로써 발언할 수 있다.
② 발언권을 얻은 자는 성명과 소속을 밝힌 후 발언의 요지를 설명하고 부연설명을 한다.
③ 다른 사람이 발언하고 있는 동안에는 발언권을 신청할 수 없다.
④ 발언권의 요청은 거수로 한다.
제 24 조 【발언 시간】
발언 시간은 다음과 같이 제한한다. 단, 발언자가 발언 시간 연장을 요청하거나 사회자가 이를 제안하는 경우 출석 정회원 과반수 찬성으로 연장할 수 있다.
  1. 각 안에 대한 제안 설명 (15분 이내)
  2. 질의 및 답변 (3분 이내)
  3. 찬반토론 (각 1분 이내)
  4. 의사진행발언 (3분 이내)
제 25 조 【의사진행발언】
① 의사진행발언은 회의 진행과 관련하여 회원이 의장에게 특정 방식으로 주재할 것을 요청하기 위하여 하는 발언이다.
② 의사진행발언이 나오면 의장은 그 발언의 수용 여부를 결정하여야 하며 해당 발언의 처리를 완료한 후 해당 발언 이전의 상태로 돌아가 안건 심의를 진행할 수 있다.
제 5 장 표 결
제 26 조 【표결】
① 표결은 비표를 이용한 거수투표로 진행함을 원칙으로 한다.
② 중요한 안건으로서 의장 또는 의사조정위원회에서 판단한 경우 무기명 표결을 위한 절차를 따른다.
제 27 조 【무기명 표결】
① 안건에 대해 무기명 표결을 진행하고자 하는 경우 출석 정회원 과반수의 동의를 얻어야 한다.
② 무기명 표결을 진행하기 위해 임시로 관리위원회를 구성할 수 있다. 관리위원회는 운영위원회 중 2인 이상으로 구성할 수 있다.
③ 무기명 표결을 진행하기 위한 모든 물품은 관리위원회에서 준비하여야 한다.
④ 무기명 표결과 관련한 세부사항은 의사조정위원회에서 결정한다.
제 28 조 【찬반 표결】
① 안건에 대한 가부를 결정하기 위한 표결은 찬반 표결로 진행한다.
② 출석 대의원 과반수 찬성으로 안건을 가결한다.
③ 가부동수일 경우 토의를 거친 후 의장이 재표결을 결정한다.
제 29 조 【복수 선택지 표결】
① 두 가지 이상의 이견안 중 하나를 결정하기 위한 표결은 복수 선택지 표결로 진행한다.
② 두 가지 이견안에 대한 표결을 진행하는 경우 두 가지 이견안 중 더 많은 지지를 받은 안으로 의결한다. 이 때, 기권이 단독 최다 득표일 경우 해당 표결은 부결된 것으로 한다.
③ 세 가지 이상의 이견안에 대한 표결을 진행하는 경우 다음 각 호의 절차를 따른다. 이 때, 기권이 단독 최다 득표세일 경우 해당 표결은 부결된 것으로 한다.
  1. 세 가지 이상의 이견안 전체에 대한 표결
  2. 세 가지 이상의 이견안 중 가장 많은 지지를 받은 두 가지 이견안 선정
  3. 선정된 두 가지 이견안에 대해 결선 표결을 진행하여 더 많은 지지를 받은 안으로 의결
제 30 조 【표결 결과 선포】
표결이 종료되면 의장은 그 결과를 집계하고 폐회 후 24시간 이내에 해당 내용을 선포하여야 한다.
제 6 장 보 칙
제 31 조 【의사록의 작성】
① 총회에서 논의된 각 호의 내용은 반드시 의사록으로 작성하여야 한다. 단, 불필요한 내용이 있다고 판단될 때에는 참석 정회원 과반수의 찬성으로 삭제할 수 있다.
  1. 회의의 종류와 명칭
  2. 회의의 년 월 일시 및 장소
  3. 출석 정회원의 수
  4. 보고사항 개요
  5. 상정된 안건에 대한 기조 발제, 질의 및 답변 그리고 각 토론자의 토론
  6. 내용에 대한 개요
  7. 각 안건의 처리 결과
  8. 기타 중요 사항
② 의사록은 의장 및 의장이 지명하는 부회장 1인과 출석 정회원 3인 이상이 기명 날인하여 보관하고, 그 내용을 회원에게 공식적인 경로를 통하여 공지하여야 한다.
부 칙
제 1 조 【발효 및 시행】
이 세부 규정은 총회에서 의결되어, 총회의 의장이 공포한 시점부터 발효, 시행된다.

인 권 보 호 및 반 성 폭 력 관 련 세 부 규 정
제 1 장 총 칙
제 1 조 【목적】
이 세부 규정은 차세대 리더로서 건전한 공동체의 분위기를 형성하여 본 모임의 구성원의 인권을 보호하고, 소속 구성원을 성폭력으로부터 보호예방 하기 위하여 필요한 제반 사항을 규정함을 목적으로 한다.
제 2 조 【정의】
① 인권침해는 대한민국 헌법과 법률이 보장하고 있는 인간으로서의 존엄과 가치, 자유와 권리를 가해자의 우월적 지위와 위력을 이용해 침해하는 행위를 말한다.
② 성폭력은 개인의 자유로운 성적 자기결정권과 인권을 침해하는 모든 신체적, 언어적, 정신적 폭력을 말한다.
제 3 조 【적용 범위】
① 본 모임의 모든 회원은 이 규정의 적용을 받으며 이 규정을 준수할 의무가 있다.
② 본 모임의 회원활동에서 인권 침해 사건이 발생하였을 때, 피해자 또는 피신고인 중 일방만이 본 모임에 소속된 경우에도 본조 1항과 같은 의무가 있다.
제 2 장 원 칙
제 4 조 【비공개 원칙】
① 인권 침해 사건을 조사, 심의, 처리하는 과정은 비공개로 진행한다.
② 인권 침해 사건의 조사를 담당하거나 담당하였던 자는 업무 처리 과정에서 알게 된 사실 및 수집된 자료를 공개하거나 타인에게 누설하여서는 안 된다. 다만, 다음 각 호의 경우에는 승인 절차에 따라 자료의 전부 또는 일부를 제공할 수 있다.
  1. 신고인이 경찰 등 수사기관에 해당 사건을 신고하기 위해 자료 제공을 요청한 경우
  2. 사건의 조사와 처리과정에서 타 기관과의 협력을 위해 필요한 경우
  3. 피해자의 명시적인 동의를 받은 경우
  4. 기타 그에 준하는 사유가 있는 경우
제 5 조 【피해자 보호 원칙】
① 인권 침해 사건의 심의조사처리 과정에서 피해자 보호를 최우선 원칙으로 고려한다.
② 신고인, 피신고인, 피해자, 조사자, 및 사건 처리에 관련된 모든 사람은 사건 관련자의 신원을 노출하거나 명예 훼손 또는 증거 인멸의 가능성이 있는 언행을 해선 안 된다.
③ 피해자는 사건의 처리 과정에서 자기 보호를 위해 필요한 조치를 요청할 수 있다.
④ 인권위원회는 특별한 사유가 없는 한 피해자의 요청을 수용해야 하며, 그밖에 피해자와의 동의하에 인권 보호를 위한 조치를 취할 수 있다.
제 6 조 【사건 분리 원칙】
① 인권 침해 사건은 모두 개별적으로 처리되어야 한다.
② 사건 당시의 구체적 상황, 당사자의 감정에 대해 임의적인 판단이 결부되어선 안 된다.
③ 사건 처리에 관련된 모든 사람에 대한 주관적 평판, 특별히 관련되지 않은 사건들과의 연관은 모두 지양해야 한다.
제 7 조 【부당 처우 금지 원칙】
① 인권 침해 사건의 처리판단 기준은 합리적객관적 원칙에 기초해야 한다.
② 사건의 피해자, 신고인 및 사건 조사에 협력한 자 등에 대하여 불이익이 가해지거나, 부당한 처우 및 2차 가해가 있어서는 안 된다.
③ 인권위원회의 조사 과정에 있어서 피신고인 혹은 가해자인 이유 만으로 적절한 조사와 논의 과정 없이 부당한 처우가 있어서는 안 된다.
제 3 장 공 동 체 의 의 무
제 8 조 【일반적 의무】
① 본 모임에서 어떤 성별, 성 정체성, 성적 지향, 가치관이 차별받지 아니하고, 평등하기 위해 모든 공동체 구성원이 이러한 문화 형성에 최선을 다할 의무가 있다.
② 인권 침해 사건은 유관자 사이에 국한되지 않고, 모든 공동체 구성원이 자기 결정권의 확보를 위해 노력해야 한다.
③ 인권 침해 사건이 발생한 경우 공동체는 피해자 보호 원칙을 포함한 상기 원칙을 적극적으로 수용해야 한다.
제 9 조 【운영 주체의 의무】
① 각 행사의 운영 주체는 인권 침해 사건을 예방하기 위해 행사 운영에 있어 적절한 조치를 취해야 한다.
② 인권위원회는 인권 침해 사건이 발생할 경우 사건을 처리하고 피해자를 지원하기 위해 적극적으로 노력하고 필요한 자원을 동원해야 한다.

제 4 장 보 칙
제 10 조 【보칙】
① 이 규정 외에 인권 침해 등 예방과 처리에 관하여 필요한 사항은 관련 법령 또는 한국공학한림원 정관을 준용한다.
부 칙
제 11 조 【발효 및 시행】
이 세부 규정은 총회에서 의결되어, 총회의 의장이 공포한 시점부터 발효, 시행된다.
                            `}} />
                        </div>
                    )} */}
                </div>
            </div>
        </>
    );
}

export default Intro;